import { Input, Tooltip } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconSearch } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { ItemReferenceApi } from "../../../apis";
import { PageFilter, PageLayout } from "../../../components/layout";
import { ColumnType, Table } from "../../../components/table";
import { Tag } from "../../../components/tags";
import RenderText from "../../../components/ui/render-text";
import { IReference } from "../../../interfaces/IReference";

export function ReferenceProductList() {
  const breadcrumbs = useBreadcrumb();
  const [query, setQuery] = useDebouncedState("", 500);

  const columns = useHeader();

  return (
    <PageLayout title="Барааны лавлах мэдээлэл" subTitle="Барааны лавлах мэдээллийн жагсаалт" breadcrumb={breadcrumbs}>
      <PageFilter
        left={[]}
        right={[
          <Tooltip key={0} label="Лавлахын нэр, кодоор хайх" color="indigo" position="top-end" withArrow>
            <Input
              onChange={(e: any) => setQuery(e.currentTarget.value)}
              placeholder="Хайлт хийх"
              rightSection={<IconSearch size={18} style={{ display: "block", opacity: 0.5 }} />}
            />
          </Tooltip>,
        ]}
      />
      <Table name="reference.list" columns={columns} filters={{ query: query, type: "" }} loadData={(data) => ItemReferenceApi.list(data!)} />
    </PageLayout>
  );
}

const useHeader = (): ColumnType<IReference>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Лавлах код",
    sorter: true,
    dataIndex: "ref",
    render: (record) => <RenderText text={record?.refCode || "-"} />,
  },
  {
    title: "Лавлах нэр",
    sorter: true,
    dataIndex: "type",
    render: (record) => {
      return (
        <Link to={`/reference/product-list/${record.listType}`}>
          <Tag name={record?.name} color="indigo.7" useHover />
        </Link>
      );
    },
  },
  {
    title: "Лавлах төрөл",
    sorter: true,
    dataIndex: "list",
    render: (record) => <Tag name={record?.listType} color="blue.5" />,
  },
  {
    title: "Тайлбар",
    sorter: true,
    dataIndex: "description",
    render: (record) => <RenderText text={record?.description || "-"} />,
  },
];

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Үндсэн",
  },
  {
    label: "Барааны лавлах мэдээлэл",
  },
];
